/**
 * @file http-error.ts
 * @description Helpers typés pour porter un status HTTP sur une Error, sans recourir à `any`
 * (convention projet). Utilisés le long de la chaîne de propagation providers → DataManager →
 * MailManager pour permettre la détection 404 en amont (`isNotFoundError`, AB#1764).
 */

/** Error porteuse d'un status HTTP typé. */
export type HttpError = Error & { status?: number };

/**
 * Crée une `Error` portant un status HTTP (points de levée des providers, ex. `!response.ok`).
 */
export function makeHttpError(message: string, status: number): HttpError {
    const err = new Error(message) as HttpError;
    err.status = status;
    return err;
}

/**
 * Ré-emballe `wrapped` en héritant du status HTTP de `source` (le long de la chaîne de
 * propagation). Renvoie `wrapped` typée `HttpError` pour un `throw` direct.
 */
export function inheritHttpStatus(wrapped: Error, source: unknown): HttpError {
    const err = wrapped as HttpError;
    err.status = (source as { status?: number } | null | undefined)?.status;
    return err;
}
